export enum DriverIdentificationType {
  Card = 'card',
  Button = 'button',
}
